import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">精品视频</span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed">
              汇聚海量高质量视频内容，涵盖教育、娱乐、生活、职场等多元领域。精选每一帧优质内容，随时随地畅享极致视听体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-background-400 text-sm hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-background-400 text-sm hover:text-primary-400 transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-background-400 text-sm hover:text-primary-400 transition-colors">用户口碑</Link></li>
              <li><Link to="/about" className="text-background-400 text-sm hover:text-primary-400 transition-colors">联系我们</Link></li>
              <li><a href="#" className="text-background-400 text-sm hover:text-primary-400 transition-colors">加入我们</a></li>
              <li><a href="#" className="text-background-400 text-sm hover:text-primary-400 transition-colors">创作者入驻</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">帮助支持</h4>
            <ul className="space-y-2.5">
              <li><a href="#" className="text-background-400 text-sm hover:text-primary-400 transition-colors">常见问题</a></li>
              <li><a href="#" className="text-background-400 text-sm hover:text-primary-400 transition-colors">用户协议</a></li>
              <li><a href="#" className="text-background-400 text-sm hover:text-primary-400 transition-colors">隐私政策</a></li>
              <li><a href="#" className="text-background-400 text-sm hover:text-primary-400 transition-colors">版权声明</a></li>
              <li><a href="#" className="text-background-400 text-sm hover:text-primary-400 transition-colors">意见反馈</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-sm">
            &copy; 2026 精品视频 JingPinVideo.com 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-background-500 text-sm hover:text-background-300 transition-colors">京ICP备2026XXXXXX号</a>
            <a href="#" className="text-background-500 text-sm hover:text-background-300 transition-colors">京公网安备 XXXXXXXXXXXX号</a>
          </div>
        </div>
      </div>
    </footer>
  );
}